import { Link } from "react-router-dom";
import { CalendarCheck, CreditCard, RotateCcw, IndianRupee, Flower2, CalendarDays, Clock, Megaphone, Plus, AlertCircle } from "lucide-react";
import { useFetch } from "../../lib/useData";
import { StatCard, PageTitle, Badge, TableWrap, Btn } from "../../components/admin/ui";

export default function Dashboard() {
  const { data: d } = useFetch("/admin/dashboard");
  if (!d) return <p className="text-slate-400">Loading dashboard…</p>;

  return (
    <div>
      <PageTitle title="Dashboard" desc="Live overview of bookings, payments and events" />

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6">
        <StatCard label="Today's Bookings" value={d.today_bookings} icon={CalendarCheck} accent="orange" testid="kpi-today-bookings" />
        <StatCard label="Confirmed Bookings" value={d.confirmed_bookings} icon={CalendarCheck} accent="emerald" testid="kpi-confirmed" />
        <StatCard label="Pending Verification" value={d.pending_verification} icon={CreditCard} accent="amber" testid="kpi-pending" />
        <StatCard label="Revenue Collected" value={`₹${d.revenue.toLocaleString("en-IN")}`} icon={IndianRupee} accent="emerald" testid="kpi-revenue" />
        {/* <StatCard label="Cancelled Bookings" value={d.cancelled_bookings} icon={RotateCcw} accent="red" testid="kpi-cancelled" /> */}
        {/* <StatCard label="Refund Requests" value={d.refund_requests} icon={RotateCcw} accent="violet" testid="kpi-refunds" /> */}
        <StatCard label="Active Sevas" value={d.active_sevas} icon={Flower2} accent="blue" testid="kpi-sevas" />
        <StatCard label="Upcoming Events" value={d.upcoming_events_count} icon={CalendarDays} accent="amber" testid="kpi-events" />
      </div>

      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <h3 className="font-display font-bold text-lg mb-3">Recent Bookings</h3>
          <TableWrap>
            <thead className="bg-slate-800 text-slate-400">
              <tr><th className="text-left px-4 py-3">Booking ID</th><th className="text-left px-4 py-3">Devotee</th><th className="text-left px-4 py-3">Seva</th><th className="text-left px-4 py-3">Date</th><th className="text-left px-4 py-3">Payment</th><th className="text-left px-4 py-3">Status</th></tr>
            </thead>
            <tbody className="divide-y divide-slate-700" data-testid="recent-bookings">
              {d.recent_bookings.map((b) => (
                <tr key={b.id} className="hover:bg-slate-800/50">
                  <td className="px-4 py-3"><Link to="/admin/bookings" className="text-orange-400 font-semibold">{b.booking_id}</Link></td>
                  <td className="px-4 py-3">{b.devotee_name}</td>
                  <td className="px-4 py-3 text-slate-300">{b.seva_name}</td>
                  <td className="px-4 py-3 text-slate-400">{b.date}</td>
                  <td className="px-4 py-3"><Badge status={b.payment_status} /></td>
                  <td className="px-4 py-3"><Badge status={b.booking_status} /></td>
                </tr>
              ))}
              {d.recent_bookings.length === 0 && <tr><td colSpan={6} className="px-4 py-8 text-center text-slate-500">No bookings yet</td></tr>}
            </tbody>
          </TableWrap>
        </div>

        <div className="space-y-6">
          <div>
            <h3 className="font-display font-bold text-lg mb-3">Quick Actions</h3>
            <div className="grid grid-cols-2 gap-2">
              <Btn variant="outline" testid="qa-add-event"><Link to="/admin/events" className="flex items-center gap-2"><Plus className="w-4 h-4" /> Event</Link></Btn>
              <Btn variant="outline" testid="qa-add-seva"><Link to="/admin/sevas" className="flex items-center gap-2"><Plus className="w-4 h-4" /> Seva</Link></Btn>
              <Btn variant="outline" testid="qa-timings"><Link to="/admin/timings" className="flex items-center gap-2"><Clock className="w-4 h-4" /> Timings</Link></Btn>
              <Btn variant="outline" testid="qa-announce"><Link to="/admin/announcements" className="flex items-center gap-2"><Megaphone className="w-4 h-4" /> Notice</Link></Btn>
              <Btn variant="outline" testid="qa-verify"><Link to="/admin/payments" className="flex items-center gap-2"><CreditCard className="w-4 h-4" /> Verify</Link></Btn>
              <Btn variant="outline" testid="qa-bookings"><Link to="/admin/bookings" className="flex items-center gap-2"><CalendarCheck className="w-4 h-4" /> Bookings</Link></Btn>
            </div>
          </div>
          <div>
            <h3 className="font-display font-bold text-lg mb-3">Upcoming Events</h3>
            <div className="space-y-2">
              {d.upcoming_events.map((e) => (
                <div key={e.id} className="bg-slate-800/60 border border-slate-700 rounded-xl px-4 py-3 flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-orange-400 shrink-0" />
                  <div><div className="font-semibold text-sm">{e.title}</div><div className="text-xs text-slate-400">{e.start_date}</div></div>
                </div>
              ))}
              {d.upcoming_events.length === 0 && <div className="text-sm text-slate-500 flex items-center gap-2"><AlertCircle className="w-4 h-4" /> No upcoming events</div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
